import styled from 'styled-components';
import theme from 'styles/theme';

export const TopNoticeWrap = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 40px;
  min-width: ${theme.layout.minWidth};
  max-width: ${theme.layout.maxWidth};
  background: lightskyblue;
  line-height: 40px;
  z-index: 11;

  p {
    color: #fff;
    font-size: 1.2rem;
    text-align: center;
    cursor: pointer;
  }

  button {
    position: absolute;
    top: 0;
    right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
  }
`;

export const BusinessManagerMsg = styled.div`
  p {
    font-weight: 400;
  }
  .title {
    padding-bottom: 20px;
    font-size: 1.6rem;
    text-align: center;
    span {
      color: #02a4ff;
    }
  }
  .desc {
    position: relative;
    padding-left: 20px;
    font-size: 1.3rem;
    line-height: 2.1rem;
    svg {
      position: absolute;
      top: 3px;
      left: 0;
    }
  }
`;
